import JackocoinsNetworkManagerMixin from "@/mixins/JackocoinsNetworkMangerMixin";
import { EServices, IVForm } from "@/types";
import { throwsNetworkError } from "@/utils/http/NetworkManagerMixin";
import { emailRule, requiredRule } from "@/utils/rules";
import { Component, Inject, Mixins, Ref, Watch } from "vue-property-decorator";
import AuthClient from "../../services/AuthClient";

@Component
export default class PasswordResetModule extends Mixins(
  JackocoinsNetworkManagerMixin
) {
  email = "";
  captchaToken = "";
  newPassword = "";
  confirmPassword = "";
  otp = "";
  activeStep = 1;

  resendPassword() {
    this.activeStep = 1;
  }

  requiredRule = requiredRule;
  emailRule = emailRule;

  @Ref()
  resetPasswordForm!: IVForm;

  @Ref()
  sendLinkForm!: IVForm;

  @Ref()
  verifyOtpForm!: IVForm;

  @Inject(EServices.auth)
  authClient!: AuthClient;

  turnstileContainerId = `turnstile-${Math.random()
    .toString(36)
    .substring(2, 10)}-reset`;

  createTurnstileWidget() {
    turnstile.render(`#${this.turnstileContainerId}`, {
      sitekey: "0x4AAAAAACxL73T6KYGIrcnM",
      theme: "light",
      callback: (token: string) => {
        this.captchaToken = token;
      },
    });
  }

  @throwsNetworkError()
  async sendLink() {
    if (!this.sendLinkForm.validate()) return;
    await this.authClient.sendPasswordOtp(this.email, this.captchaToken);
    toast({
      message: `Your password reset link has been sent`,
      icon: "mdi-check",
      iconColor: "green",
    });
    this.activeStep = 2;
  }

  @throwsNetworkError()
  async verifyOtp() {
    if (!this.verifyOtpForm.validate()) return;
    await this.authClient.verifyPasswordOtp(this.otp, this.email);
    toast({
      message: `OTP verified.`,
      icon: "mdi-check",
      iconColor: "green",
    });
    this.activeStep = 3;
  }

  @throwsNetworkError()
  async savePassword() {
    if (!this.resetPasswordForm.validate()) return;
    if (this.newPassword !== this.confirmPassword) {
      toast({
        icon: "mdi-exclamation-thick",
        iconColor: "red",
        message: "Password mismatch",
      });
      return;
    }
    await this.authClient.resetPassword(this.email, this.newPassword, this.otp);
    const message = `Your new password has been saved successfully.`;
    toast({
      icon: "mdi-check",
      iconColor: "green",
      message,
    });
    this.$router.replace("/login");
  }

  @Watch("error.savePassword")
  @Watch("error.sendLink")
  @Watch("error.verifyOtp")
  onNetworkError(message: string) {
    if (message)
      toast({
        icon: "mdi-exclamation-thick",
        iconColor: "red",
        message,
      });
  }

  mounted() {
    this.createTurnstileWidget();
  }
}
